import { render } from "./Settings.vue?vue&type=template&id=7df4fa14"
const script = {}
script.render = render

export default script